import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface SubscriptionGuardProps {
    children: React.ReactNode;
}

export const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ children }) => {
    const { company, isSuperAdmin, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-[#0A0A0A]">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    // Superadmins and parent companies can always bypass the subscription lock
    if (isSuperAdmin || company?.is_parent_company) {
        return <>{children}</>;
    }

    // Check if subscription is valid
    const isInactive = company?.subscription_status === 'inactive' || company?.subscription_status === 'canceled' || company?.subscription_status === 'past_due';
    
    // auto_block === false: cobrança controlada à mão, vencimento não barra o acesso
    let isExpired = false;
    if (company?.subscription_end_date && company.settings?.auto_block !== false) {
        const endDate = new Date(company.subscription_end_date);
        const now = new Date();
        isExpired = now > endDate;
    }

    if ((isInactive || isExpired) && location.pathname !== '/subscription-expired' && location.pathname !== '/login') {
        return <Navigate to="/subscription-expired" replace />;
    }

    return <>{children}</>;
};
